module.exports = __webpack_public_path__ + "img/8@2x.ea2d30e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/8@2x.png
// module id = 07jF
// module chunks = 0